import { render, staticRenderFns } from "./TimeSimple.vue?vue&type=template&id=87ac9824&scoped=true"
import script from "./TimeSimple.vue?vue&type=script&lang=js"
export * from "./TimeSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ac9824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87ac9824')) {
      api.createRecord('87ac9824', component.options)
    } else {
      api.reload('87ac9824', component.options)
    }
    module.hot.accept("./TimeSimple.vue?vue&type=template&id=87ac9824&scoped=true", function () {
      api.rerender('87ac9824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/TimeSimple.vue"
export default component.exports